function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { Layout, PaperIcon } from '@nackle/paper';
const {
  Footer
} = Layout;
import './app-footer.less';
class AppFooter extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleFeedbackClick", e => {
      e.preventDefault();
      const {
        onFeedbackClick
      } = this.props;
      if (typeof onFeedbackClick === 'function') {
        onFeedbackClick();
      }
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(Footer, {
      className: "app-footer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "copyright"
    }, "Copyright \xA9 ", new Date().getFullYear(), " BI WORLDWIDE\xAE All Rights Reserved."), /*#__PURE__*/React.createElement("a", {
      href: "/feedback",
      onClick: this.handleFeedbackClick
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(PaperIcon, {
      icon: "LampBright"
    }), " Ideas? ", /*#__PURE__*/React.createElement(PaperIcon, {
      icon: "Bug2"
    }), " Problems? Let us know!")));
  }
}
export default AppFooter;
//# sourceMappingURL=app-footer.js.map